import { GET_DATA_ROLES_ALL_SUCCEEDED, REQUERT_ROLES_ALL_FAILED } from "../actions/actionTypes";

const roleReducer = (DataRoles = [], actions) =>{
    switch (actions.type) {
        case GET_DATA_ROLES_ALL_SUCCEEDED:
            if(Object.keys(actions.DataRoles).length > 0)
            {
              return {...DataRoles, DataRoles: actions.DataRoles};
            }
            else
            {
                return {...DataRoles, DataRoles: []} ;
            }
        case REQUERT_ROLES_ALL_FAILED:
            return {...DataRoles, DataRoles: []} ;
        default:
            return DataRoles;
    }
}

export default roleReducer;